import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';
import { FileType } from '@/hooks/useFileLoading';
import { Moment } from 'moment';

export enum WorkOrderTypesFilter {
  courtesy = 'domain.enums.work_order_type.courtesy',
  warranty = 'domain.enums.work_order_type.warranty',
  workOrder = 'domain.enums.work_order_type.work_order',
  totalLoss = 'domain.enums.work_order_type.total_loss',
  return = 'domain.enums.work_order_type.return',
  revision = 'domain.enums.work_order_type.revision',
}

export enum DREQuestReportType {
  competence = 'competence',
  default = 'default',
}

export interface QuestDREReportRequest {
  companiesIds?: string;
  planAccountIds?: string;
  startDate: string;
  endDate: string;
  reportResponseType: FileType;
  workOrderTypesFilter: WorkOrderTypesFilter;
  groupPlanAccounts?: boolean;
}

export type QuestDREAccrualReportRequest = Omit<
  QuestDREReportRequest,
  'planAccountIds'
>;

export interface DREFormValues extends ReportDateInterface {
  initialDate: Moment;
  finalDate: Moment;
  planAccountIds: number[];
  workOrderTypesFilter: WorkOrderTypesFilter;
  dreQuestReportType: DREQuestReportType;
  groupPlanAccounts?: boolean;
}
